import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  Tabs,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Avatar,
  Row,
  Col,
  Modal,
  Radio,
} from "antd";

import Main from "../../components/layout/Main";
import BreadcrumbArrow from "../../assets/images/breadcrumb-image-arrow.svg";
import ProfileImage from "../../assets/images/leaderboard-profile.jpg";
import BronzeImage from "../../assets/images/bronze-button-image.svg";
import SilverImage from "../../assets/images/silver-butto-image.svg";
import GoldImage from "../../assets/images/gold-button-image.svg";
import { useTournament } from "../../context/TournamentContext";
import { X } from "lucide-react";
import { Severty, ShowToast } from "../../helper/toast";

const { TextArea } = Input;

const CreatePrivateTournament = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  // const [selected, setSelected] = useState("gold");
  const [selectedTrophies, setSelectedTrophies] = useState(["Gold"]);

  const {
    loadPlayerInTournament,
    gamesList,
    seasonsList,
    genersList,
    createPrivateTournament,
  } = useTournament();

  const getButtonClass = (type) => {
    return selectedTrophies.includes(type)
      ? "selected-trophy-button"
      : "normal-trophy-button";
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tournamentPlayers, setTournamentPlayers] = useState([]);
  const [gameLists, setGameLists] = useState([]);
  const [geners, setGeners] = useState([]);
  const [activeTab, setActiveTab] = useState("online");
  const [username, setUsername] = useState("");
  const [playerName, setPlayerName] = useState("");
  const [invitePlayer, setInvitePlayer] = useState([]);
  const [invitedPlayers, setInvitedPlayers] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [gameId, setGameId] = useState();
  const [allowSolo, setAllowSolo] = useState(true);
  const [players, setPlayers] = useState([
    { name: "PlayerOne", avatar: ProfileImage },
    { name: "NinjaMaster", avatar: ProfileImage },
  ]);

  const fetchTournamentPlayers = async () => {
    try {
      const response = await loadPlayerInTournament({
        mode: activeTab,
        username,
      });
      if (response.status === 200) {
        setTournamentPlayers(response.data.data.users);
      }

      // ----- Game Lists ----
      const result = await gamesList({
        status: "Active",
      });
      if (result.status === 200) {
        setGameLists(result.data.data.games);
      }

      // ------ Geners List --------
      const genersResponse = await genersList({ status: "Active" });
      if (genersResponse.status === 200) {
        setGeners(genersResponse.data.data.genres);
      }
    } catch (error) {
      console.log("Error occured one tournament player", error);
    }
  };

  const fetchSeasons = async () => {
    try {
      // ---- Season Lists ----
      const seasonResponse = await seasonsList(gameId);
      if (seasonResponse.status === 200) {
        setSeasons(seasonResponse.data.data.seasons);
      }
    } catch (error) {
      console.log("Error occured while get season", error);
    }
  };

  const handleAddPlayer = (invitePlayers) => {
    // ✅ Save to localStorage
    localStorage.setItem("invitePlayers", JSON.stringify(invitePlayers));
    ShowToast("Player added successfully", Severty.SUCCESS);
    form.setFieldsValue({
      invitedUserIds: invitePlayers.map((p) => p._id),
    });
    setIsModalOpen(false);
    fetchTournamentPlayers();
  };

  const toggleInvite = (player) => {
    setInvitePlayer((prev) => {
      const exists = prev.some((p) => p._id === player._id);
      return exists
        ? prev.filter((p) => p._id !== player._id) // unselect
        : [...prev, player]; // select
    });
  };

  const handleRemovePlayer = (name) => {
    setPlayers(players.filter((p) => p.name !== name));
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const format = Form.useWatch("format", form);
  // ----------- Create Private Tournament -------------
  const onFinish = async (values) => {
    try {
      values.roundsConfig = "auto";
      values.status = "private";
      values.endDate = null;
      const response = await createPrivateTournament(values);
      if (response.status === 200) {
        ShowToast(response.data.message, Severty.SUCCESS);
        form.resetFields();
        navigate("/private-tournaments");
      }
    } catch (error) {
      console.log("Error occured while creating tournament", error);
      ShowToast(error.message, Severty.ERROR);
    }
  };

  const toggleTrophy = (value) => {
    let updated = [...selectedTrophies];

    // 🔴 REMOVE logic
    if (updated.includes(value)) {
      if (value === "Gold") {
        // removing Gold removes everything
        updated = [];
      } else if (value === "Silver") {
        // removing Silver also removes Bronze
        updated = updated.filter((t) => t !== "Silver" && t !== "Bronze");
      } else if (value === "Bronze") {
        updated = updated.filter((t) => t !== "Bronze");
      }
    }
    // 🟢 ADD logic
    else {
      if (value === "Silver" && !updated.includes("Gold")) return;

      if (
        value === "Bronze" &&
        (!updated.includes("Gold") || !updated.includes("Silver"))
      )
        return;

      updated.push(value);
    }

    setSelectedTrophies(updated);
    form.setFieldsValue({ trophyStructure: updated });
  };

  useEffect(() => {
    fetchTournamentPlayers();
  }, [activeTab, username, gameId]);

  useEffect(() => {
    const storedPlayers = localStorage.getItem("invitePlayers");
    if (storedPlayers) {
      setInvitedPlayers(JSON.parse(storedPlayers));
    }
  }, []);

  useEffect(() => {
    fetchSeasons();
  }, [gameId]);

  // useEffect(() => {
  //   const type = form.getFieldValue("format");

  //   // 🔥 1. When BR → Always only Gold trophy
  //   if (type === "BR") {
  //     setSelectedTrophies(["Gold"]);
  //     form.setFieldsValue({ trophyStructure: ["Gold"] });
  //     return;
  //   }

  //   if (!teamSizeValue) {
  //     setSelectedTrophies([]);
  //     form.setFieldsValue({ trophyStructure: [] });
  //     return;
  //   }

  //   const size = Number(teamSizeValue);
  //   let trophies = [];

  //   if (size <= 2) {
  //     trophies = ["Gold"];
  //   } else if (size === 3) {
  //     trophies = ["Gold", "Silver"];
  //   } else if (size > 3) {
  //     trophies = ["Gold", "Silver", "Bronze"];
  //   }

  //   setSelectedTrophies(trophies);
  //   form.setFieldsValue({ trophyStructure: trophies });
  // }, [teamSizeValue, form, form.getFieldValue("format")]);

  useEffect(() => {
    const type = form.getFieldValue("format");

    // When type changes to "BR" → set default values only once
    if (type === "BR") {
      form.setFieldsValue({
        totalPlayerSize: 1,
        eliminationType: "Single",
        trophyStructure: ["Gold"],
      });
    }
  }, [form, form.getFieldValue("format")]);

  return (
    <Main>
      <Breadcrumb
        className="for-route-path-head"
        separator={<img src={BreadcrumbArrow} alt=">" />}
      >
        <Breadcrumb.Item
          onClick={() => navigate("/private-tournaments")}
          style={{ cursor: "pointer" }}
        >
          Tournament
        </Breadcrumb.Item>
        <Breadcrumb.Item>Private</Breadcrumb.Item>
        <Breadcrumb.Item>Create Private Tournament</Breadcrumb.Item>
      </Breadcrumb>
      <div className="create-private-tournament">
        <div className="games-versoin-name-header">
          <h4>Create Private Tournament</h4>
        </div>

        <Form
          layout="vertical"
          form={form}
          className="tournament-form"
          onFinish={onFinish}
          initialValues={{
            tournamentType: "solo",
            allowSolo: true,
          }}
        >
          <Row gutter={24}>
            <Col span={24} md={10}>
              <Form.Item
                label="Tournament Name"
                name="name_en"
                rules={[
                  { required: true, message: "Please enter tournament name" },
                ]}
              >
                <Input placeholder="Enter tournament name" />
              </Form.Item>

              <Form.Item
                label="Tournament name in arabic سم البطول"
                name="name_ar"
                rules={[
                  { required: true, message: "الرجاء إدخال اسم البطولة" },
                ]}
              >
                <Input placeholder="أدخل اسم البطولة" />
              </Form.Item>

              <Form.Item
                label="Game"
                name="game"
                rules={[{ required: true, message: "Please select a game" }]}
              >
                <Select
                  placeholder="Select a Game"
                  onChange={(value) => {
                    setGameId(value);
                    form.setFieldsValue({ game: value });
                  }}
                >
                  {gameLists &&
                    gameLists.map((game) => (
                      <Select.Option key={game._id} value={game._id}>
                        {game?.name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Season"
                name="season"
                rules={[{ required: true, message: "Please select a season" }]}
              >
                <Select placeholder="Select a Season">
                  {seasons &&
                    seasons.map((season) => (
                      <Select.Option key={season._id} value={season._id}>
                        {season?.name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Geners"
                name="genres"
                rules={[{ required: true, message: "Please select a genre" }]}
              >
                <Select placeholder="Select a Genre" mode="multiple">
                  {geners &&
                    geners.map((gener) => (
                      <Select.Option key={gener._id} value={gener._id}>
                        {gener?.title}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Tournament Type"
                name="format"
                rules={[{ required: true, message: "Please choose a type" }]}
              >
                <Select placeholder="Select Tournament Type">
                  <Select.Option value="Solo">Solo</Select.Option>
                  <Select.Option value="Team">Team</Select.Option>
                  <Select.Option value="BR">Battle Royals</Select.Option>
                </Select>
              </Form.Item>

              {(format === "BR" || format === "Team") && (
                <Form.Item label="Solo Players Allowed" required>
                  <div style={{ display: "flex", gap: 8 }}>
                    <Button
                      type={allowSolo ? "primary" : "default"}
                      className={allowSolo ? "Fill-button" : "light-button"}
                      onClick={() => {
                        setAllowSolo(true);
                        form.setFieldsValue({ allowSolo: true });
                      }}
                    >
                      Allow Solo
                    </Button>

                    <Button
                      type={!allowSolo ? "primary" : "default"}
                      className={!allowSolo ? "Fill-button" : "light-button"}
                      onClick={() => {
                        setAllowSolo(false);
                        form.setFieldsValue({ allowSolo: false });
                      }}
                    >
                      Don’t Allow
                    </Button>
                  </div>
                </Form.Item>
              )}
              {/* Conditional fields based on tournamentType */}
              <Form.Item
                shouldUpdate={(prevValues, curValues) =>
                  prevValues.format !== curValues.format
                }
              >
                {() => {
                  const type = form.getFieldValue("format");
                  // ⭐ UI for BR format
                  if (type === "BR") {
                    return (
                      <>
                        {/* <Form.Item
                          label="Max Teams"
                          name="teamSize"
                          rules={[
                            {
                              required: true,
                              message: "Please enter max team",
                            },
                            {
                              validator: (_, value) => {
                                if (!value) return Promise.resolve();

                                // Check even
                                if (value % 2 !== 0) {
                                  return Promise.reject(
                                    "Only even numbers are allowed"
                                  );
                                }

                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input type="number" placeholder="Enter team size" />
                        </Form.Item> */}

                        {/* player size → always 1 → disabled */}
                        <Form.Item
                          label="Players"
                          name="totalPlayerSize"
                          rules={[
                            {
                              required: true,
                              message: "Please enter max players",
                            },
                          ]}
                        >
                          <Input
                            type="number"
                            min={1}
                            max={100}
                            placeholder="Enter Total Players"
                          />
                        </Form.Item>

                        <Form.Item
                          label="Elimination Type"
                          name="eliminationType"
                          rules={[
                            {
                              required: true,
                              message: "Please select elimination type",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select elimination type"
                            disabled
                          >
                            <Select.Option value="Single">Single</Select.Option>
                            <Select.Option value="Double">Double</Select.Option>
                          </Select>
                        </Form.Item>
                      </>
                    );
                  }
                  // SOLO → only teamSize
                  if (type === "Solo") {
                    return (
                      <>
                        {/* <Form.Item
                          label="Max Teams"
                          name="teamSize"
                          rules={[
                            {
                              required: true,
                              message: "Please enter max teams",
                            },
                            {
                              validator: (_, value) => {
                                if (!value) return Promise.resolve();

                                // Check even
                                if (value % 2 !== 0) {
                                  return Promise.reject(
                                    "Only even numbers are allowed"
                                  );
                                }

                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input type="number" placeholder="2, 4, 6 ..." />
                        </Form.Item> */}
                        <Form.Item
                          label="Players"
                          name="totalPlayerSize"
                          rules={[
                            {
                              required: true,
                              message: "Please enter total players",
                            },
                          ]}
                        >
                          <Input
                            type="number"
                            min={1}
                            max={100}
                            placeholder="Total Players"
                          />
                        </Form.Item>
                        <Form.Item
                          label="Elimination Type"
                          name="eliminationType"
                          rules={[
                            {
                              required: true,
                              message: "Please select elimination type",
                            },
                          ]}
                        >
                          <Select placeholder="Select elimination type">
                            <Select.Option value="Single">Single</Select.Option>
                            <Select.Option value="Double">Double</Select.Option>
                          </Select>
                        </Form.Item>
                      </>
                    );
                  }

                  // TEAM / OTHER → both teamSize + totalPlayerSize
                  return (
                    <>
                      <Form.Item
                        label="Teams"
                        name="teamSize"
                        rules={[
                          { required: true, message: "Please enter max teams" },
                          {
                            validator: (_, value) => {
                              if (!value) return Promise.resolve();

                              // Check even
                              if (value % 2 !== 0) {
                                return Promise.reject(
                                  "Only even numbers are allowed",
                                );
                              }

                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input
                          type="number"
                          placeholder="Enter team like 2, 4, 6 ..."
                        />
                      </Form.Item>

                      <Form.Item
                        label="Players"
                        name="totalPlayerSize"
                        rules={[
                          {
                            required: true,
                            message: "Please enter max players",
                          },
                        ]}
                      >
                        <Input
                          type="number"
                          min={1}
                          max={100}
                          placeholder="e.g. 32"
                        />
                      </Form.Item>

                      <Form.Item
                        label="Elimination Type"
                        name="eliminationType"
                        rules={[
                          {
                            required: true,
                            message: "Please select elimination type",
                          },
                        ]}
                      >
                        <Select placeholder="Select elimination type">
                          <Select.Option value="Single">Single</Select.Option>
                          <Select.Option value="Double">Double</Select.Option>
                        </Select>
                      </Form.Item>
                    </>
                  );

                  return null; // other formats → show nothing here
                }}
              </Form.Item>

              {/* <Form.Item
                label="Entry Fees"
                name="entryFee"
                rules={[
                  {
                    required: true,
                    message: "Please enter entree fee",
                  },
                ]}
              >
                <Input type="number" placeholder="50" />
              </Form.Item> */}

              {/* <Form.Item
                label="Stream Link"
                name="streamLink"
                rules={[
                  {
                    required: true,
                    message: "Please enter stream fee",
                  },
                ]}
              >
                <Input placeholder="Enter stream link" />
              </Form.Item> */}

              <Form.Item
                label="Start Date & Time"
                name="startDate"
                rules={[
                  {
                    required: true,
                    message: "Please select start date & time",
                  },
                ]}
              >
                <DatePicker
                  showTime
                  format="MM/DD/YYYY HH:mm"
                  style={{ width: "100%" }}
                />
              </Form.Item>

              <Form.Item label="Rules & Conditions" name="rules">
                <TextArea
                  rows={4}
                  placeholder="Describe any extra conditions (optional)"
                />
              </Form.Item>

              <Form.Item
                label="Trophy Structure"
                name="trophyStructure"
                rules={[
                  { required: true, message: "Select at least one trophy" },
                ]}
              >
                <div className="button-raiting-groupp">
                  <Button
                    className={getButtonClass("Gold")}
                    // onClick={() => toggleTrophy("Gold")}
                  >
                    <img
                      src={GoldImage}
                      alt="Gold"
                      style={{
                        height: 16,
                        marginRight: 4,
                        filter: "contrast(5.5)",
                      }}
                    />
                    Gold
                  </Button>

                  <Button
                    className={getButtonClass("Silver")}
                    onClick={() => toggleTrophy("Silver")}
                  >
                    <img
                      src={SilverImage}
                      alt="Silver"
                      style={{ height: 16, marginRight: 8 }}
                    />
                    Silver
                  </Button>

                  <Button
                    className={getButtonClass("Bronze")}
                    onClick={() => toggleTrophy("Bronze")}
                  >
                    <img
                      src={BronzeImage}
                      alt="Bronze"
                      style={{ height: 16, marginRight: 8 }}
                    />
                    Bronze
                  </Button>
                </div>
              </Form.Item>

              <div className="cancel-and-submit-button">
                <Button
                  className="light-button"
                  onClick={() => form.resetFields()}
                >
                  Cancel
                </Button>
                <Button className="Fill-button" htmlType="submit">
                  Create Tournament
                </Button>
              </div>
            </Col>

            <Col span={24} md={10}>
              <Form.Item
                name="invitedUserIds"
                rules={[
                  {
                    validator: () =>
                      invitePlayer.length > 0
                        ? Promise.resolve()
                        : Promise.reject("Please invite at least one player"),
                  },
                ]}
              >
                <div className="invite-players-box">
                  <div className="invite-header">
                    <h4>
                      Invite Players <span style={{ color: "red" }}>*</span>
                    </h4>
                    <a onClick={showModal} style={{ color: "orange" }}>
                      Add
                    </a>
                  </div>

                  {invitePlayer.map((player, idx) => (
                    <div key={idx} className="player-item">
                      <div className="profil-image-and-name">
                        <img
                          src={player.profilePic || ProfileImage}
                          alt={player.username || player.name}
                        />
                        <span>{player.username || player.name}</span>
                      </div>
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          // remove explicitly (works even if user clicks X)
                          setInvitePlayer((prev) =>
                            prev.filter((p) => p._id !== player._id),
                          );
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6B7280"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M18 6 6 18" />
                          <path d="m6 6 12 12" />
                        </svg>
                      </span>
                    </div>
                  ))}
                </div>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      <Modal
        className="custom-modal"
        title="Add Players"
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
      >
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={[
            { key: "online", label: "Online" },
            { key: "inhouse", label: "In-house" },
          ]}
          className="add-player-tabs"
        />

        {activeTab === "online" && (
          <div>
            <div
              className="add-player-form-in-tournament"
              style={{ margin: "10px" }}
            >
              <Form layout="vertical">
                <Form.Item label="Search user by username" name="username">
                  <Input
                    placeholder="Enter player username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="custom-input"
                  />
                </Form.Item>
              </Form>
              <Button
                block
                className="Fill-button"
                onClick={() => handleAddPlayer(invitePlayer)}
              >
                Add
              </Button>
            </div>
            {tournamentPlayers.map((player) => {
              const isSelected = invitePlayer.some((p) => p._id === player._id);

              return (
                <div
                  className={`player-item ${isSelected ? "selected" : ""} `}
                  key={player._id}
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleInvite(player)}
                >
                  <div className="profil-image-and-name">
                    <Avatar src={player.profilePic} />
                    <span>{player.username || player.name}</span>
                  </div>

                  <div className="right-icons">
                    {isSelected && <span className="pill">Chosen</span>}
                    <X
                      onClick={(e) => {
                        e.stopPropagation();
                        // remove explicitly (works even if user clicks X)
                        setInvitePlayer((prev) =>
                          prev.filter((p) => p._id !== player._id),
                        );
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {activeTab === "inhouse" && (
          <div>
            <div
              className="add-player-form-in-tournament"
              style={{ margin: "10px" }}
            >
              <Form layout="vertical">
                <Form.Item label="Search user by username" name="username">
                  <Input
                    placeholder="Enter player user name"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="custom-input"
                  />
                </Form.Item>
              </Form>
              <Button
                block
                className="Fill-button"
                style={{ marginTop: "20px" }}
                onClick={() => handleAddPlayer(invitePlayer)}
              >
                Add
              </Button>
            </div>
            {tournamentPlayers.map((player) => {
              const isSelected = invitePlayer.some((p) => p._id === player._id);

              return (
                <div
                  className={`player-item ${isSelected ? "selected" : ""}`}
                  key={player.username}
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleInvite(player)}
                >
                  <div className="profil-image-and-name">
                    <Avatar src={player.profilePic} />
                    <span>{player.username || player.name}</span>
                  </div>

                  <div className="right-icons">
                    {isSelected && <span className="pill">Chosen</span>}
                    <X
                      onClick={(e) => {
                        e.stopPropagation();
                        // remove explicitly (works even if user clicks X)
                        setInvitePlayer((prev) =>
                          prev.filter((p) => p._id !== player._id),
                        );
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Modal>
    </Main>
  );
};

export default CreatePrivateTournament;
